import React from 'react';
import '../App.css'
const ResumeButton: React.FC = () => {
    const openLink = () => {
        window.open("https://s3.us-east-2.amazonaws.com/grantdewaay.com/gdewaayResume.pdf", "_blank");
      };
    return (
        <button onClick={openLink} className='border-[2px] border-faded-back text-s text-faded-back font-sans font-bold inline-block px-2 hover:bg-faded-back hover:text-faded-black rounded-lg transition-all'>Resume</button>

    );
};

export default ResumeButton;
